// tslint:disable:no-any

import * as React from 'react';

export interface IDiveConfirmModalProps {
    hideConfirmSubmit: () => void;
    submitDivesData: (e: Event) => void;
    title: string;
    description: string;
    display: boolean;
}

interface IDiveConfirmModalState {
    display: boolean;
}

export default class DiveConfirmModal extends React.Component<
    IDiveConfirmModalProps,
    IDiveConfirmModalState
> {
    constructor(props: IDiveConfirmModalProps) {
        super(props);

        this.state = {
            display: props.display
        };
    }

    componentWillReceiveProps(nextProps: IDiveConfirmModalProps) {
        this.setState({
            display: nextProps.display
        });
    }

    hideModal() {
        this.props.hideConfirmSubmit();
    }

    onClickConfirm(e: Event) {
        this.hideModal();
        this.props.submitDivesData(e);
        e.preventDefault();
    }

    onClickStorno(e: Event) {
        this.hideModal();
        e.preventDefault();
    }

    render() {
        return (
            <div
                className={
                    'modalOverlay' + (this.state.display ? '' : ' hidden')
                }
            >
                <div className="modalSlide">
                    <div className="modal">
                        <button
                            className="close"
                            onClick={e => this.onClickStorno(e as any)}
                        />
                        <div className="modal-header">
                            <h3>{this.props.title}</h3>
                        </div>
                        <div className="modal-content">
                            <p>{this.props.description}</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn--xsmallpill btn--borderRed btn--colorRed"
                                onClick={e => this.onClickStorno(e as any)}
                            >
                                Add missing data
                            </button>
                            <i onClick={e => this.onClickConfirm(e as any)}>
                                Yes, save anyway
                            </i>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveConfirmModal.tsx